export enum EFieldGroupUsageType {
  FIELD_GROUP = 1,
  SERVICE = 2,
  AD_HOC_SERVICE = 3,
  AFTER_ENTRY_GROUP = 4
}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/form-builder/enums/e-group-usage-type.enum.ts